import React, {useEffect} from 'react';
import {
  ISimpleSubInfoSettings,
  ISimpleSubMainPageContent,
  ISimpleSubProduct,
  ISimpleSubSummaryPageContent
} from './types';
import SimpleSubBuilder from './Components/SimpleSubBuilder';
import {rechargeSubService} from '../../../../scripts/vendor/recharge/subscription/rechargeSubService';

interface SimpleSubPortalProps {
  dataSet: DOMStringMap;
}

const SimpleSubPortal: React.FunctionComponent<SimpleSubPortalProps> = ({dataSet}: SimpleSubPortalProps) => {
  const [shopifyData, setShopifyData] = React.useState(null);

  // Can't be combined as we're using different sections to build the page content.
  useEffect((): void => {
    const productsString: string = document.querySelector('[data-simple-sub-products]').textContent;
    const productsJson: ISimpleSubProduct[] = JSON.parse(productsString);

    const mainContentStr: string = document.querySelector('[data-simple-sub-main-content]').textContent;
    const mainContentJson: ISimpleSubMainPageContent = JSON.parse(mainContentStr);

    const infoSettingsStr: string = document.querySelector('[data-simple-sub-info-settings]').textContent;
    const infoSettingsJson: ISimpleSubInfoSettings = JSON.parse(infoSettingsStr);

    const summarySettingsStr: string = document.querySelector('[data-simple-sub-summary]').textContent;
    const summarySettingsJson: ISimpleSubSummaryPageContent = JSON.parse(summarySettingsStr);

    const langStrings = JSON.parse(dataSet.langStrings);

    setShopifyData({
      products: productsJson,
      settings: {
        mainContent: mainContentJson,
        infoSettings: infoSettingsJson,
        summaryContent: summarySettingsJson
      },
      langStrings
    });
  }, []);

  if (shopifyData) {
    return <SimpleSubBuilder shopifyData={shopifyData} subService={rechargeSubService}/>;
  }

  return null;
};

export default SimpleSubPortal;